import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X, ArrowRight } from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";
import logo from "@/Assets/logo.png";
const navLinks = [
  // { href: '/features', label: 'Features' },
  { href: "/about", label: "About" },
  { href: "/Who-We-Serve", label: "Who We Serve " },
  { href: "/pricing", label: "Pricing" },
  { href: "/security", label: "Security" },
];

export const Navbar = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  const isActive = (path) => location.pathname === path;

  return (
    <header
      className="fixed top-0 left-0 right-0 z-50 bg-white/90 backdrop-blur-md border-b border-neutral-200/50"
      data-testid="navbar"
    >
      <nav className="container-width">
        <div className="flex items-center justify-between h-16 md:h-20">
          {/* Logo */}
          <Link
            to="/"
            className="flex items-center gap-2"
            data-testid="navbar-logo"
          >
            <img
              src={logo}
              alt="Bridge Format AIQ"
              className="h-8 sm:h-9 md:h-10 w-auto max-w-[140px] sm:max-w-[160px] md:max-w-[180px] object-contain"
            />
            {/* <span
              className="text-lg md:text-xl font-bold tracking-tight text-neutral-950"
              style={{ fontFamily: "Manrope, sans-serif" }}
            >
              Bridge Format AIQ
            </span> */}
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden lg:flex items-center gap-8">
            {navLinks.map((link) => (
              <Link
                key={link.href}
                to={link.href}
                className={`text-sm font-medium transition-colors ${
                  isActive(link.href)
                    ? "text-neutral-950"
                    : "text-neutral-600 hover:text-neutral-950"
                }`}
                data-testid={`nav-link-${link.label.toLowerCase().replace(" ", "-")}`}
              >
                {link.label}
              </Link>
            ))}
          </div>

          {/* Desktop CTA */}
          <div className="hidden lg:flex items-center gap-4">
            <Link
              to="/contact-us"
              className="btn-primary gap-2 btn-hover-scale"
              data-testid="navbar-demo-btn"
            >
              Request Demo
              <ArrowRight className="w-4 h-4" />
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="lg:hidden p-2"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            aria-label="Toggle menu"
            data-testid="mobile-menu-btn"
          >
            {mobileMenuOpen ? (
              <X className="w-6 h-6 text-neutral-950" />
            ) : (
              <Menu className="w-6 h-6 text-neutral-950" />
            )}
          </button>
        </div>

        {/* Mobile Menu */}
        <AnimatePresence>
          {mobileMenuOpen && (
            <motion.div
              initial={{ opacity: 0, height: 0 }}
              animate={{ opacity: 1, height: "auto" }}
              exit={{ opacity: 0, height: 0 }}
              transition={{ duration: 0.2 }}
              className="lg:hidden border-t border-neutral-200"
              data-testid="mobile-menu"
            >
              <div className="py-4 space-y-1">
                {navLinks.map((link) => (
                  <Link
                    key={link.href}
                    to={link.href}
                    onClick={() => setMobileMenuOpen(false)}
                    className={`block py-3 text-sm font-medium ${
                      isActive(link.href)
                        ? "text-neutral-950"
                        : "text-neutral-600"
                    }`}
                  >
                    {link.label}
                  </Link>
                ))}
                <Link
                  to="/contact-us"
                  onClick={() => setMobileMenuOpen(false)}
                  className="block mt-4"
                >
                  <span className="btn-primary w-full gap-2">
                    Request Demo
                    <ArrowRight className="w-4 h-4" />
                  </span>
                </Link>
              </div>
            </motion.div>
          )}
        </AnimatePresence>
      </nav>
    </header>
  );
};

export default Navbar;
